import { StackedMetricsStatusChartSection } from '@/features/shared/components/chartPanels/StackedMetricsStatusChartSection';
import { getChartTitle } from '@/shared/copy/charts';
import { getEmptyStateMessage } from '@/shared/copy/emptyStates';
import type { MetricCardItem } from '@/features/metrics/components/statusMetricCards';
import type { MetricsStatusChartPanelModelToolbarState } from '@/features/shared/components/chartPanels/useMetricsStatusChartPanelModel';
import type { MetricsToolbarTagOption } from '@/features/shared/components/metricsToolbar/metricsToolbarTagOptions';
import type { TableStatusOption } from '@/features/shared/components/tableSystem/tableToolbar.types';
import type { MetricThresholdGroupKey } from '@/shared/utils/metricsThresholds';
import type { SuiteRunStatus } from '@flowqa/shared';
import type { ReactElement } from 'react';

type ExecutionRunsPageChartsProps = {
  availableTags: MetricsToolbarTagOption[];
  groupErroredWithFailed: boolean;
  loading: boolean;
  metricCards: MetricCardItem[];
  onStatusToggle: (status: SuiteRunStatus) => void;
  projectId: string | null;
  selectedStatusIds: string[];
  showPoints: boolean;
  statusFilterLabel?: string;
  statusOptions: Array<TableStatusOption<SuiteRunStatus>>;
  suppressAnimation: boolean;
  toolbarState: MetricsStatusChartPanelModelToolbarState<SuiteRunStatus>;
  visibleMetricKeys: MetricThresholdGroupKey[];
};

export const ExecutionRunsPageCharts = ({
  availableTags,
  groupErroredWithFailed,
  loading,
  metricCards,
  onStatusToggle,
  projectId,
  selectedStatusIds,
  showPoints,
  statusFilterLabel,
  statusOptions,
  suppressAnimation,
  toolbarState,
  visibleMetricKeys,
}: ExecutionRunsPageChartsProps): ReactElement => (
  <StackedMetricsStatusChartSection<SuiteRunStatus>
    title={getChartTitle('statusTimeline')}
    searchAriaLabel="Search stacked execution run chart data"
    noRowsBaseText={getEmptyStateMessage('entity.noneFound', { entity: 'executionRun' })}
    scope="executionRun"
    projectId={projectId}
    availableTags={availableTags}
    metricCards={metricCards}
    loading={loading}
    statusCardSkeletonCount={groupErroredWithFailed ? 4 : 5}
    selectedStatusIds={selectedStatusIds}
    onStatusToggle={(status) => {
      if (status === 'total') return;
      onStatusToggle(status as SuiteRunStatus);
    }}
    toolbarState={toolbarState}
    suppressAnimation={suppressAnimation}
    showPoints={showPoints}
    statusOptions={statusOptions}
    statusFilterLabel={statusFilterLabel}
    visibleMetricKeys={visibleMetricKeys}
  />
);
